import { defineMessages } from 'react-intl-next';

export default defineMessages({
	previewLozenge: {
		id: 'smart-creation.preview.lozenge',
		defaultMessage: 'Preview',
		description: 'Lozenge informing the user that the content is in preview mode.',
	},
});
